"use client";
import { FunctionComponent, ReactNode, useReducer } from "react";
import { ChartContext } from "./context";
import {
  clearChartContext,
  setChartData,
  setFareBreakup,
  setLoading,
  setSelectedDropoff,
  setSelectedPickup,
  setSelectedSeats,
} from "./action";
import { reducer } from "./reducer";
import { initialState } from "./store";
import {
  Seat,
  ChartData,
  PickUpData,
  DropOffData,
} from "src/containers/chart/types";
import { Action, ChartFareBreakup, ChartStore } from "./types";
interface Props {
  children: ReactNode;
}

const ChartProvider: FunctionComponent<Props> = (props) => {
  const [state, dispatch] = useReducer<React.Reducer<ChartStore, Action>>(
    reducer,
    initialState
  );
  const value = {
    chartData: state.chartData,
    selectedSeats: state.selectedSeats,
    fareBreakup: state.fareBreakup,
    selectedPickup: state.selectedPickup,
    selectedDropoff: state.selectedDropoff,
    loading: state.loading,
    setChartData: (data: ChartData) => {
      dispatch(setChartData(data));
    },
    setSelectedSeats: (data: Seat[]) => {
      dispatch(setSelectedSeats(data));
    },
    setLoading: (data: string) => {
      dispatch(setLoading(data));
    },
    setFareBreakup: (data: ChartFareBreakup) => {
      dispatch(setFareBreakup(data));
    },
    setSelectedPickup: (data: PickUpData) => {
      dispatch(setSelectedPickup(data));
    },
    setSelectedDropoff: (data: DropOffData) => {
      dispatch(setSelectedDropoff(data));
    },
    clearChartContext: () => {
      dispatch(clearChartContext());
    },
  };

  return (
    <ChartContext.Provider value={value}>
      {props.children}
    </ChartContext.Provider>
  );
};

export default ChartProvider;
